import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import SpeedoMeter from "../common/graph/speedo-meter";

const TURBOCHARGER_INDICATOR_ORDER = [
  "Shock index",
  "Level RMS(mm/s)",
  "Bearing Damage",
  "Unbalance Instability",
];

const Turbocharger = ({ indicatorData }: any) => {
  const [renderData, setRenderData] = React.useState<any>();

  React.useEffect(() => {
    setRenderData(indicatorData);
  }, [indicatorData]);

  const globalIndicator = (renderData?.globalIndicator || [])
    .filter((item: any) =>
      TURBOCHARGER_INDICATOR_ORDER.includes(item.indicatorName)
    )
    .sort(
      (a: any, b: any) =>
        TURBOCHARGER_INDICATOR_ORDER.indexOf(a.indicatorName) -
        TURBOCHARGER_INDICATOR_ORDER.indexOf(b.indicatorName)
    );

  return (
    <Box>
      <Grid item xs={12} my={"20px"}>
        <Grid
          sx={{ padding: "0 70px" }}
          container
          alignItems={"center"}
          justifyContent="center"
          spacing={6}
        >
          {globalIndicator.map((val: any) => (
            <Grid
              key={`globalIndicator-${val.indicatorName}`}
              item
              sx={{ display: "flex", flexDirection: "column" }}
              lg={6}
              md={6}
              sm={6}
              xs={12}
            >
              <Typography
                variant="body1"
                component={"span"}
                textAlign={"center"}
                sx={{
                  mb: 1,
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "20px",
                }}
                title={val?.tooltip}
              >
                {val?.indicatorName}
              </Typography>
              <Box
                sx={{
                  height: "65%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "20px",
                }}
              >
                <SpeedoMeter
                  maxValue={val.indicatorMax}
                  isGradientOpposite={val?.isGradientOpposite}
                  minValue={val?.indicatorMin}
                  value={val?.indicatorValue}
                  isPercent={val?.isPercentage}
                  isGradientColor={val?.isGradientColor}
                  indicatorType={val?.indicatorType}
                  indicatorUnit={val?.indicatorUnit}
                  isTorqueModule={val?.isTorqueModule}
                  indicatorName={val?.indicatorName}
                  height={150}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Turbocharger;
